import { render, staticRenderFns } from "./uni-collapse-item.vue?vue&type=template&id=1a56bf70"
import script from "./uni-collapse-item.vue?vue&type=script&lang=js"
export * from "./uni-collapse-item.vue?vue&type=script&lang=js"
import style0 from "./uni-collapse-item.vue?vue&type=style&index=0&id=1a56bf70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports